import { useMutation, useQuery } from '@tanstack/react-query';

import {
  completeCognitoNewPassword,
  forgetCognitoDevice,
  getCognitoDevices,
  getCognitoNewCodePassword,
  getCognitoUser,
  rememberCognitoDevice,
  resetCognitoPassword,
  signInCognito,
} from '../../services';

export const useSignInCognitoUser = () => {
  return useMutation({
    mutationKey: ['sign_in_cognito_user'],
    mutationFn: signInCognito,
    // Wrong-password sign-in must fail on the first attempt (spec
    // Requirement 1, Scenario 3) — retrying would add ~3s of delay before
    // surfacing a NotAuthorizedException the wrapper already treats as
    // non-retryable.
    retry: 0,
  });
};

export const useAsyncGetCurrentCognitoUser = () => {
  return useMutation({
    mutationKey: ['get_async_current_cognito_user'],
    mutationFn: getCognitoUser,
  });
};

export const useGetCurrentCognitoUser = (config?: { silent: boolean }) => {
  return useQuery({
    queryKey: ['fetch_current_cognito_user'],
    queryFn: () => {
      return getCognitoUser({ silent: config.silent ?? true });
    },
  });
};

export const useForgetCognitoDevice = () => {
  return useMutation({
    mutationKey: ['forget_cognito_device'],
    mutationFn: forgetCognitoDevice,
  });
};

export const useRememberCognitoDevice = () => {
  return useMutation({
    mutationKey: ['remember_cognito_device'],
    mutationFn: rememberCognitoDevice,
  });
};

export const useGetCognitoDevices = () => {
  return useQuery({
    queryKey: ['get_cognito_devices'],
    queryFn: getCognitoDevices,
  });
};

export const useAsyncGetCognitoDevices = () => {
  return useMutation({
    mutationKey: ['get_cognito_devices'],
    mutationFn: getCognitoDevices,
  });
};

export const useCompleteCognitoNewPassword = () => {
  return useMutation({
    mutationKey: ['complete_new_password'],
    mutationFn: completeCognitoNewPassword,
  });
};

export const useGetCognitoNewCodePassword = () => {
  return useMutation({
    mutationKey: ['forgot_cognito_password'],
    mutationFn: getCognitoNewCodePassword,
  });
};

export const useForgotCognitoPassword = () => {
  return useMutation({
    mutationKey: ['reset_cognito_password'],
    mutationFn: resetCognitoPassword,
  });
};
